var RemoveAllChess = function (destroy) {
    this.board.removeAllChess(destroy);
    return this;
}

export default RemoveAllChess;